<script lang="ts" setup>
import MaterialSymbolsArrowForwardIosRounded from '~icons/material-symbols/arrow-forward-ios-rounded'
import BLabel from '@/components/common/bLabel.vue'

const props = defineProps<{
  invoice: {
    _id: string
    display: string
    invoiceNumber: string
    project: {
      _id: string
      display: string,
      client: {
        display: string
      }
    }
  }
}>()
const emit = defineEmits<{
  closeSearch: []
}>()
</script>

<template>
  <RouterLink :to="{ name: 'InvoiceProject', params: { projectId: invoice.project._id } }"
    class="w-full flex flex-wrap gap-4 group transition flex cursor-default items-center rounded-md px-2 py-1 group hover:bg-primary-600 hover:cursor-pointer"
    role="option" @click="emit('closeSearch')">

    <div class="flex gap-1">
      <BLabel v-if="invoice.project" size="dense">
        {{ invoice.project.client.display }}
      </BLabel>
    </div>
    <p class="ml-3 flex-auto truncate group-hover:text-white">
      {{ invoice.invoiceNumber }} - {{ invoice.project.display }}
    </p>
    <MaterialSymbolsArrowForwardIosRounded class="ml-3 h-5 w-5 flex-none group-hover:text-white" />

  </RouterLink>
</template>
